(function () {
  'use strict';

  function formatMoney(cents, symbol) {
    var units = Math.round(cents / 100);
    var str = units.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symbol + ' ' + str;
  }

  /* ----- Sort dropdowns (desktop bar + mobile pills) ----- */
  function initSort() {
    var selects = document.querySelectorAll('[data-hf-sort]');
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ----- Mobile filters drawer ----- */
  function initFiltersDrawer() {
    var drawer = document.getElementById('FiltersDrawer');
    var backdrop = document.querySelector('.filters-backdrop');
    if (!drawer) return;

    function setOpen(open) {
      document.body.classList.toggle('filters-open', open);
      if (backdrop) backdrop.hidden = !open;
    }

    document.querySelectorAll('[data-filters-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(true); });
    });
    document.querySelectorAll('[data-filters-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ----- Facet form (checkboxes auto-submit) ----- */
  function initFacets() {
    var form = document.querySelector('[data-hf-facets]');
    if (!form) return;
    form.addEventListener('change', function (event) {
      if (event.target && event.target.type === 'checkbox') {
        form.submit();
      }
    });
  }

  /* ----- Collapsible filter heads ----- */
  function initToggles() {
    var heads = document.querySelectorAll('[data-filter-toggle]');
    heads.forEach(function (head) {
      head.addEventListener('click', function () {
        var filter = head.closest('.filter');
        if (filter) filter.classList.toggle('is-collapsed');
      });
    });
  }

  /* ----- Price range slider ----- */
  function initPriceSlider() {
    var slider = document.querySelector('[data-price-slider]');
    if (!slider) return;

    var track = slider.querySelector('.price-slider__track');
    var fill = slider.querySelector('.price-slider__fill');
    var minHandle = slider.querySelector('.price-slider__handle--min');
    var maxHandle = slider.querySelector('.price-slider__handle--max');
    var labelMin = slider.querySelector('[data-price-label-min]');
    var labelMax = slider.querySelector('[data-price-label-max]');
    var inputMin = slider.querySelector('[data-price-input-min]');
    var inputMax = slider.querySelector('[data-price-input-max]');
    var form = slider.closest('form');

    var symbol = slider.dataset.symbol || '';
    var floor = parseInt(slider.dataset.floor, 10) || 0;
    var ceil = parseInt(slider.dataset.ceil, 10) || 0;
    if (ceil <= floor) return;

    var minVal = slider.dataset.min !== '' ? parseInt(slider.dataset.min, 10) : floor;
    var maxVal = slider.dataset.max !== '' ? parseInt(slider.dataset.max, 10) : ceil;
    if (isNaN(minVal)) minVal = floor;
    if (isNaN(maxVal)) maxVal = ceil;

    var range = ceil - floor;

    function pct(value) {
      return ((value - floor) / range) * 100;
    }

    function render() {
      var minPct = pct(minVal);
      var maxPct = pct(maxVal);
      minHandle.style.left = minPct + '%';
      maxHandle.style.left = maxPct + '%';
      fill.style.left = minPct + '%';
      fill.style.width = (maxPct - minPct) + '%';
      labelMin.textContent = formatMoney(minVal, symbol);
      labelMax.textContent = formatMoney(maxVal, symbol) + (maxVal >= ceil ? '+' : '');
    }

    function commitInputs() {
      if (minVal > floor) {
        inputMin.value = Math.round(minVal / 100);
        inputMin.disabled = false;
      } else {
        inputMin.value = '';
        inputMin.disabled = true;
      }
      if (maxVal < ceil) {
        inputMax.value = Math.round(maxVal / 100);
        inputMax.disabled = false;
      } else {
        inputMax.value = '';
        inputMax.disabled = true;
      }
    }

    var dragging = null;

    function valueFromEvent(clientX) {
      var rect = track.getBoundingClientRect();
      var ratio = (clientX - rect.left) / rect.width;
      ratio = Math.min(1, Math.max(0, ratio));
      var raw = floor + ratio * range;
      var step = Math.max(1, Math.round(range / 100));
      return Math.round(raw / step) * step;
    }

    function onMove(clientX) {
      var value = valueFromEvent(clientX);
      if (dragging === 'min') {
        minVal = Math.min(value, maxVal);
      } else if (dragging === 'max') {
        maxVal = Math.max(value, minVal);
      }
      render();
    }

    function pointerMove(e) {
      if (!dragging) return;
      onMove(e.touches ? e.touches[0].clientX : e.clientX);
    }

    function pointerUp() {
      if (!dragging) return;
      dragging = null;
      document.removeEventListener('mousemove', pointerMove);
      document.removeEventListener('mouseup', pointerUp);
      document.removeEventListener('touchmove', pointerMove);
      document.removeEventListener('touchend', pointerUp);
      commitInputs();
      if (form) form.submit();
    }

    function startDrag(which) {
      return function (e) {
        e.preventDefault();
        dragging = which;
        document.addEventListener('mousemove', pointerMove);
        document.addEventListener('mouseup', pointerUp);
        document.addEventListener('touchmove', pointerMove, { passive: false });
        document.addEventListener('touchend', pointerUp);
      };
    }

    minHandle.addEventListener('mousedown', startDrag('min'));
    minHandle.addEventListener('touchstart', startDrag('min'), { passive: false });
    maxHandle.addEventListener('mousedown', startDrag('max'));
    maxHandle.addEventListener('touchstart', startDrag('max'), { passive: false });

    render();
    commitInputs();
  }

  function init() {
    initSort();
    initFacets();
    initToggles();
    initPriceSlider();
    initFiltersDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
